import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Sparkle, ArrowRight } from "@phosphor-icons/react";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("admin@proxiqtech.ai");
    const [password, setPassword] = useState("Admin@123");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        const r = await login(email, password);
        setLoading(false);
        if (r.ok) navigate("/");
        else setError(r.error);
    };

    return (
        <div className="min-h-screen flex">
            {/* Left brand panel */}
            <div
                className="hidden md:flex flex-col justify-between w-1/2 p-12 relative overflow-hidden"
                style={{
                    backgroundImage:
                        "url(https://images.unsplash.com/photo-1597773150796-e5c14ebecbf5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="absolute inset-0 bg-slate-950/70 backdrop-blur-sm" />
                <div className="relative z-10 flex items-center gap-3">
                    <div className="h-11 w-11 rounded-xl bg-gradient-to-br from-blue-500 to-cyan-400 grid place-items-center btn-glow">
                        <Sparkle weight="fill" size={22} />
                    </div>
                    <div>
                        <div className="font-display text-lg font-bold">PROXIQ TECH AI</div>
                        <div className="text-[10px] tracking-[0.3em] text-slate-300 font-bold">
                            BUSINESS OPERATING SYSTEM
                        </div>
                    </div>
                </div>

                <div className="relative z-10 max-w-md">
                    <div className="label-uppercase mb-3">Built for founders</div>
                    <h1 className="font-display text-5xl font-bold leading-[1.05] tracking-tight">
                        Orders. Invoices. Coaching.
                        <br />
                        <span className="bg-gradient-to-r from-blue-400 via-cyan-300 to-violet-400 bg-clip-text text-transparent">
                            One quiet platform.
                        </span>
                    </h1>
                    <p className="mt-5 text-slate-300/90 leading-relaxed">
                        Run your entire business from a single command center — orders,
                        khatabook, payments, invoices and coaching admissions.
                    </p>
                </div>

                <div className="relative z-10 text-xs text-slate-400">
                    Designed & Managed by Proxiq Tech AI · Aynul Memon — Founder
                </div>
            </div>

            {/* Right form */}
            <div className="flex-1 flex items-center justify-center p-6 md:p-12 grid-bg">
                <div className="w-full max-w-md glass-card p-8 gradient-border animate-fade-up">
                    <div className="md:hidden flex items-center gap-3 mb-6">
                        <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-blue-500 to-cyan-400 grid place-items-center">
                            <Sparkle weight="fill" />
                        </div>
                        <div className="font-display text-lg font-bold">PROXIQ TECH AI</div>
                    </div>

                    <div className="label-uppercase">Welcome back</div>
                    <h2 className="font-display text-3xl font-bold mt-2">
                        Sign in to your workspace
                    </h2>
                    <p className="text-sm text-slate-400 mt-2">
                        Use your admin credentials to continue.
                    </p>

                    <form onSubmit={onSubmit} className="mt-6 space-y-4">
                        <div>
                            <label className="label-uppercase">Email</label>
                            <input
                                data-testid="login-email"
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="mt-2 w-full bg-white/5 border border-white/10 rounded-xl px-3.5 py-3 text-sm focus:outline-none focus:border-blue-500/60 focus:ring-1 focus:ring-blue-500/40"
                                placeholder="you@company.com"
                            />
                        </div>
                        <div>
                            <label className="label-uppercase">Password</label>
                            <input
                                data-testid="login-password"
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="mt-2 w-full bg-white/5 border border-white/10 rounded-xl px-3.5 py-3 text-sm focus:outline-none focus:border-blue-500/60 focus:ring-1 focus:ring-blue-500/40"
                                placeholder="••••••••"
                            />
                        </div>

                        {error && (
                            <div
                                data-testid="login-error"
                                className="text-sm text-rose-300 bg-rose-500/10 border border-rose-500/30 rounded-lg px-3 py-2"
                            >
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={loading}
                            data-testid="login-submit"
                            className="w-full inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-500 disabled:opacity-60 text-white font-semibold rounded-xl py-3 btn-glow transition"
                        >
                            {loading ? "Signing in…" : "Continue"}
                            <ArrowRight weight="bold" size={16} />
                        </button>
                    </form>

                    <div className="mt-6 text-xs text-slate-500 text-center">
                        Default admin: <span className="font-mono text-slate-300">admin@proxiqtech.ai</span> /{" "}
                        <span className="font-mono text-slate-300">Admin@123</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
